<script>
  import {_} from '../../translations';
  import ButtonsWrapper from '../wrappers/ButtonsWrapper.svelte';
  import CloseIcon from '../elements/CloseIcon.svelte';
  import Button from '../elements/Button.svelte';
  import IntroLogo from '../elements/IntroLogo.svelte';
  import {sbrowserEnabled} from '../../utils/sbrowser';
  import {PAGE_PURPOSES, PAGE_VENDORS, USER_INT, USER_EXT} from '../../constants';

  export let hasPrevConsent = false;
  export let userType = '';
  export let submiting = false;
  export let userLoggedIn = false;
  export let consentPage = false;

  const consentText = hasPrevConsent ? 'descriptionPrev' : 'description';
  const simpleDialog = hasPrevConsent && consentPage;
</script>

<CloseIcon on:exit screen={1} />
<div class="scmp_Box scmp_Intro-wrapper scmp_Scrollable-content-wrapper">
  <header>
    {#if userType === USER_INT}
      <IntroLogo />
    {/if}
    <hgroup>
      <h1 class="scmp_SectionTitle scmp_SectionTitle--intro">
        {@html _('intro.title')}
      </h1>
      <h2 class="scmp_SectionSubtitle scmp_SectionSubtitle--intro">
        {@html _(`intro.subTitle${simpleDialog ? 'Continue' : ''}`)}
      </h2>
    </hgroup>
  </header>
  <div class="scmp_IntroText">
    {#if simpleDialog}
      <p>
        {@html _('intro.simpleDialog')}
      </p>
    {:else}
      {#if userType === USER_INT}
        <p>
          {@html _(`intro.${consentText}1`)}
          <br />
          {@html _(`intro.${consentText}11`)}
          <Button on:buttonClick screen={1} label={_('intro.vendorButton')} type="link" navigation={PAGE_VENDORS} />
          {@html _(`intro.${consentText}2`)}
          {#if userLoggedIn}
            {@html _(`intro.${consentText}2Logged`)}
          {:else}
            {@html _(`intro.${consentText}2Unlogged`)}
          {/if}
        </p>
        <p>
          {@html _(`intro.${consentText}22`)}
        </p>
      {/if}

      {#if userType === USER_EXT}
        <p>
          {@html _(`intro.external.${consentText}1`)}
          <br />
          {@html _(`intro.external.${consentText}11`)}
          <Button on:buttonClick screen={1} label={_('intro.external.vendorButton')} type="link" navigation={PAGE_VENDORS} />
          {@html _(`intro.external.${consentText}2`)}
        </p>
        <p>
          {@html _(`intro.external.${consentText}22`)}
        </p>
      {/if}
    {/if}

  </div>
  {#if userType === USER_INT && sbrowserEnabled()}
    <div class="scmp_IntroBox">
      {@html _(`intro.seznamBrowserMessage`)}
    </div>
  {/if}
</div>

<ButtonsWrapper>
  <Button on:buttonClick label={_(`button.${simpleDialog ? 'editSettings' : 'next'}`)} type="next" navigation={PAGE_PURPOSES} />
  <Button on:buttonClick disabled={submiting} screen={1} label={_(`button.${simpleDialog ? 'continue' : 'agree'}`)} type="submit" />
</ButtonsWrapper>
